/** Slug for `/brands/manufacturers/{slug}.png` static assets. */
const MANUFACTURER_SLUG_ALIASES: Record<string, string> = {
  'sony ericsson': 'sony-ericsson',
  'benq-siemens': 'benq-siemens',
  'garmin-asus': 'garmin-asus',
  'lemon mobiles': 'lemon-mobiles',
  'firefly mobile': 'firefly-mobile',
  'sierra wireless': 'sierra-wireless',
  'tag heuer': 'tag-heuer',
  't-mobile': 't-mobile',
  'zen mobile': 'zen-mobile',
  'airo wireless': 'airo-wireless',
  'general mobile': 'general-mobile',
  icemobile: 'icemobile',
  'i-mobile': 'i-mobile',
  'i-mate': 'i-mate',
}

export function manufacturerLogoSlug(manufacturer: string): string {
  const key = manufacturer.trim().toLowerCase()
  if (MANUFACTURER_SLUG_ALIASES[key]) return MANUFACTURER_SLUG_ALIASES[key]
  return key
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
}

export const MANUFACTURER_LOGO_ORIGIN = 'https://redevicer.com'

export function manufacturerLogoPath(manufacturer: string): string {
  return `/brands/manufacturers/${manufacturerLogoSlug(manufacturer)}.png`
}

const LOGO_VERSION = 'v=6'

/** Relative path for web `<img src>` (same origin). */
export function manufacturerLogoSrc(manufacturer: string): string {
  return `${manufacturerLogoPath(manufacturer)}?${LOGO_VERSION}`
}

/** Absolute URL for mobile / external clients. */
export function manufacturerLogoUrl(
  manufacturer: string,
  origin: string = MANUFACTURER_LOGO_ORIGIN,
): string {
  return `${origin}${manufacturerLogoPath(manufacturer)}?${LOGO_VERSION}`
}
